import { ReactNode } from "react";

import { ButtonWrapper } from "./Button.style";

export type ButtonStyle =
  | "primary"
  | "secondary-a"
  | "secondary-b"
  | "secondary-c"
  | "secondary-d"
  | "danger";

interface ButtonProps {
  /**
   * Button label
   */
  children: ReactNode;
  /**
   * Button's type
   * @default primary
   */
  buttonStyle?: ButtonStyle;
  /**
   * Set button to disable state
   */
  disable?: boolean;
  /**
   * Set button to have full width
   */
  fullWidth?: boolean;
  /**
   * Set button to use icon label style
   */
  isIconButton?: boolean;
  /**
   * Called when clicked button
   */
  onClick?: () => void;
}

export const Button = (props: ButtonProps) => {
  const {
    children,
    disable,
    onClick,
    buttonStyle = "primary",
    ...ButtonProps
  } = props;

  return (
    <ButtonWrapper
      onClick={() => {
        !disable && onClick && onClick();
      }}
      buttonStyle={buttonStyle}
      disable={disable}
      {...ButtonProps}
    >
      {children}
    </ButtonWrapper>
  );
};
